module.exports = __webpack_public_path__ + "img/newsletter.5fb58f4b.png";